import React, {useState} from 'react';

import styles from '../../modules/Filters.module.scss';

const Index = ({element, onChange, loadingFilters, onclickGAEvent, gaActionName}) => {
    const [checked, setChecked] = useState(element.checked);

    const isDisabled = element.disabled;

    return (<div className={`${styles.dropdownItem} ${isDisabled ? styles.disabled : ""}`}>
        <div className={styles.filterCheckbox}>
            <input
                className={styles.filterCheckboxInput}
                type="radio"
                name={element.name}
                id={element.id}
                value={element.value}
                defaultChecked={checked}
                disabled={isDisabled}
                onChange={() => {
                    if (isDisabled) return;
                    onChange({
                        ...element, checked: true //radio button is always true
                    });
                    setChecked(!checked);
                    loadingFilters(true);
                    onclickGAEvent({
                        action: 'FP - By ' + gaActionName, label: element.label,
                    });
                }}
            />
            <label
                className={styles.filterCheckboxLabel}
                htmlFor={element.id}
            >
                {element.label}
            </label>
        </div>
    </div>);
};

export default Index;